export default {
	appAll : [],
	appIDactual: localStorage.getItem('appIDactual') || 0,   
	modulos: [],
	listAvailableApps: [],
	appRolUser: [],
	adminApp: false,
	planIdApp: localStorage.getItem('planIdApp') || 1, // standard
	modulesMenu: (localStorage.getItem('modulesMenu')!=null) ? JSON.parse(localStorage.getItem('modulesMenu')) : [], // menu de plan
	orderApp: [
        {name: "Smart Office", id:"1"},
        {name: "bSales", id:"14"},
        {name: "Projects", id:"3"},
        {name: "Marketea", id:"8"},
        {name: "Jobs", id:"4"},
        {name: "RoofCal", id:"5"},
        {name: "Sites", id:"2"},
        {name: "bRem", id:"15"},
        {name: "Slabs", id:"7"},
        {name: "Display", id:"10"},
        {name: "Tutor", id:"13"},
	],
}
